import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules'; // 修改导入路径
import 'swiper/swiper-bundle.css';
import imgPrefix from '../imgConfig'; // 导入 imgConfig.js
import axios from '../axiosConfig';

const Carousel = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const loadImages = async () => {
      try {
        // 和后台 config 列表保持一致，通过 name 模糊匹配 picture
        const res = await axios.get('/config/list', {
          params: {
            page: 1,
            limit: 10,
            sort: 'id',
            name: '%picture%',
          },
        });
        if (
          res.data &&
          res.data.code === 0 &&
          res.data.data.list &&
          res.data.data.list.length > 0
        ) {
          const list = res.data.data.list;
          const paths = [];
          list.forEach((row) => {
            if (row.value) {
              row.value.split(',').forEach((p) => {
                const trimmed = (p || '').trim();
                if (trimmed) {
                  paths.push(trimmed);
                }
              });
            }
          });
          if (paths.length > 0) {
            setImages(paths);
            return;
          }
        }
      } catch (e) {
        console.error('Failed to load carousel images from config', e);
      }

      // 回退到原来的两张默认图
      setImages(['upload/carosel1.jpg', 'upload/carosel2.jpg']);
    };

    loadImages();
  }, []);

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <Swiper
      modules={[Autoplay]}
      pagination={{ clickable: true }}
      loop
      autoplay={{ delay: 2000 }}
    >
      {images.map((path, idx) => (
        <SwiperSlide key={idx}>
          <img
            src={`${imgPrefix}/${path}`}
            alt={`Banner ${idx + 1}`}
            style={{ width: '100%' }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Carousel;
